module.exports = __webpack_public_path__ + "media/stylesheets/images/boxil/BOXIL SaaS AWARD Summer 2024_Good Service-503768dccac342ae5edae012bb83a928.png";